export default __webpack_public_path__ + "static/media/4.26f88ac9.png";